import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Card,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import key1 from "../Images/key1.svg";
import pay from "../Images/pay.png";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import Nav from "./Navbar";
import Footer from "./Footer";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { MdContentPaste } from "react-icons/md";
import SideTab from "./Toolstab";
import Testimonials from "./Testonomial";
import { FaArrowRight } from "react-icons/fa";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const Contentquality = () => {
  const resultRef = useRef(null);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [readability, setReadability] = useState(null);
  const [seoKeywords, setSeoKeywords] = useState([]);
  const analyzeKeywordDensity = (text) => {
    const stopWords = new Set([
      "the",
      "is",
      "in",
      "and",
      "to",
      "a",
      "of",
      "for",
      "on",
      "with",
      "as",
      "by",
      "at",
      "an",
      "this",
      "that",
      "it",
    ]);
    const words = text
      .toLowerCase()
      .replace(/[^a-z\s]/g, "")
      .split(/\s+/)
      .filter((word) => word && !stopWords.has(word));
    const totalWords = words.length;
    const frequency = {};
    words.forEach((word) => {
      frequency[word] = (frequency[word] || 0) + 1;
    });
    const keywordData = Object.entries(frequency)
      .map(([word, count]) => ({
        word,
        count,
        density: ((count / totalWords) * 100).toFixed(2),
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 10);
    return keywordData;
  };

  const calculateReadability = (text) => {
    const sentences = text.split(/[.?!]+/).filter(Boolean);
    const words = text.split(/\s+/).filter(Boolean);
    const wordCount = words.length;
    const sentenceCount = sentences.length || 1;
    const syllableCount = wordCount * 1.5;
    const fleschReadingEase =
      206.835 -
      1.015 * (wordCount / sentenceCount) -
      84.6 * (syllableCount / wordCount);

    return {
      fleschReadingEase: Math.max(0, Math.min(fleschReadingEase, 100)),
      sentenceCount,
    };
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const handleAnalyze = async () => {
    setLoading(true);
    if (!content.trim()) {
      setError("Please paste some content before analyzing.");
      setResult(null);
      setReadability(null);
      return;
    }
    setError("");
    setResult(null);
    setReadability(null);

    try {
      const readabilityScore = calculateReadability(content);
      setReadability(readabilityScore);
      const keywords = analyzeKeywordDensity(content);
      setSeoKeywords(keywords);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/ContentAnalysis/ContentChecker`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ text: content }),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        setResult(data.data);
        setTimeout(() => {
          resultRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else {
        setError("Failed to analyze content.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("An error occurred while analyzing the content.");
    }
    setLoading(false);
  };

  const twoDecimalPlaces = (value) => {
    return Number(value).toFixed(2).toString();
  };
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Content Quality Checker Online | Improve SEO Fast",
    url: "https://seobix.com/content-quality-checker",
    description:
      "Check your content quality instantly! Detect errors, improve readability, and optimize for SEO. Get higher rankings with our free quality content checker tool.",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Content Quality Checker",
          item: "https://seobix.com/content-quality-checker",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Content Quality Checker",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "content quality checker tool",
      "quality content checker",
      "content quality checking tool",
      "seo content quality checker",
      "content quality checking tool online",
      "low quality content checker",
      "content quality checker",
      "website content quality checker",
      "check content quality online",
      "content quality checker tool",
      "high quality content checker",
      "quality content checker",
      "seo content quality checker",
      "online content quality checker",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is a Content Quality Checker?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A Content Quality Checker is a tool that analyzes your website or article content for errors, readability, and SEO optimization to improve rankings.",
        },
      },
      {
        "@type": "Question",
        name: "How does Seobix Content Quality Checker work?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Seobix Content Quality Checker scans your content instantly, detects issues, and provides suggestions to improve readability and SEO performance.",
        },
      },
      {
        "@type": "Question",
        name: "Is Seobix Content Quality Checker free?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, the Content Quality Checker tool on Seobix is completely free and helps optimize your content for better SEO results.",
        },
      },
    ],
  };
  return (
    <Container fluid className="p-0" style={{ overflowX: "clip" }}>
      <div>
        <Helmet>
          <title>Content Quality Checker Online | Improve SEO Fast</title>
          <meta
            name="description"
            content="Check your content quality instantly! Detect errors, improve readability, and optimize for SEO. Get higher rankings with our free quality content checker tool."
          />
          <meta
            name="keywords"
            content="content quality checker tool, quality content checker, content quality checking tool, seo content quality checker, content quality checking tool online, low quality content checker, content quality checker, website content quality checker, check content quality online, content quality checker tool, high quality content checker, quality content checker, seo content quality checker, online content quality checker"
          />
          <link
            rel="canonical"
            href="https://seobix.com/content-quality-checker"
          />

          <meta
            property="og:title"
            content="Content Quality Checker Online | Improve SEO Fast"
          />
          <meta
            property="og:description"
            content="Check your content quality instantly! Detect errors, improve readability, and optimize for SEO. Get higher rankings with our free quality content checker tool."
          />
          <meta
            property="og:url"
            content="https://seobix.com/content-quality-checker"
          />
          <meta property="og:site_name" content="Seobix" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="600" />
          <meta property="og:locale" content="en_US" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Content Quality Checker Online | Improve SEO Fast"
          />
          <meta
            name="twitter:description"
            content="Check your content quality instantly! Detect errors, improve readability, and optimize for SEO. Get higher rankings with our free quality content checker tool."
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta name="twitter:site" content="@seobix" />
          <meta name="twitter:creator" content="@seobix" />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mb-5">
        <Col md={10} className="mt-4">
          <h1 className="mb-3 text-center">
            <b>Content Quality Checker</b>
          </h1>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="contentTextarea"
              style={{ position: "relative" }}
            >
              <MdContentPaste
                style={{
                  position: "absolute",
                  top: "18px",
                  left: "20px",
                  fontSize: "1.5rem",
                  color: "#ccc",
                  pointerEvents: "none",
                  zIndex: "1",
                }}
              />
              <Form.Control
                as="textarea"
                rows={18}
                placeholder="Paste your content here..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
                style={{
                  fontSize: "1rem",
                  padding: "1.25rem 1.25rem 1.25rem 3rem",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                  transition: "box-shadow 0.3s ease-in-out",
                  resize: "vertical",
                  minHeight: "250px",
                }}
              />
            </Form.Group>
            <Button
              variant="primary"
              onClick={handleAnalyze}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Analyze"}
            </Button>
          </Form>

          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}

          {(result || readability) && (
            <div className="mt-4" ref={resultRef}>
              <h5 className="mb-2 text-center">Analysis Summary</h5>
              <Row className="g-4 mt-2 p-0">
                <Col md={6}>
                  {result && (
                    <>
                      <Row className="g-2 p-0">
                        <Col className="px-1" md={6}>
                          <GaugeCard
                            title="AI Words"
                            value={result.aiWords}
                            max={result.textWords || 1000}
                            color="#0d6efd"
                          />
                        </Col>
                        <Col className="px-1" md={6}>
                          <GaugeCard
                            title="Plagiarism %"
                            value={result.fakePercentage}
                            max={100}
                            color="#dc3545"
                          />
                        </Col>
                      </Row>
                      <Row className="g-2 mt-1 p-0">
                        <Col className="px-1" md={6}>
                          <GaugeCard
                            title="Human %"
                            value={result.isHuman}
                            max={100}
                            color="#198754"
                          />
                        </Col>
                        <Col className="px-1" md={6}>
                          <GaugeCard
                            title="Word Count"
                            value={result.textWords}
                            max={2000}
                            color="#6f42c1"
                          />
                        </Col>
                      </Row>
                    </>
                  )}

                  {result && readability && (
                    <>
                      <Row className="g-2 mt-1 p-0">
                        <Col className="px-1" md={6}>
                          <GaugeCard
                            title="Readability"
                            value={twoDecimalPlaces(
                              readability.fleschReadingEase
                            )}
                            max={100}
                            color="#17a2b8"
                          />
                        </Col>
                        <Col className="px-1" md={6}>
                          <GaugeCard
                            title="Sentences"
                            value={readability.sentenceCount}
                            max={100}
                            color="#fd7e14"
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>

                <Col md={6} className="d-flex justify-content-center">
                  {result && seoKeywords.length > 0 && (
                    <div
                      className="p-3 border rounded bg-light "
                      style={{
                        height: "70vh",
                        overflow: "auto",
                        scrollbarWidth: "none",
                      }}
                    >
                      <h6 className="mb-3 text-center">
                        🔍 SEO Keyword Density (Top 10)
                      </h6>
                      <p className="text-muted small text-center mb-2">
                        Showing most-used keywords excluding common words.
                      </p>

                      <table
                        className="table table-sm table-bordered mb-0"
                        style={{ fontSize: "0.95rem" }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Keyword</th>
                            <th>Occurrences</th>
                            <th>Density (%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {seoKeywords.map((item, idx) => (
                            <tr key={idx}>
                              <td>
                                <b>{item.word}</b>
                              </td>
                              <td>{item.count}</td>
                              <td>{item.density}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </Col>
              </Row>

              {result?.otherFeedback && (
                <div className="mt-4">
                  <h6>Feedback</h6>
                  <div className="p-3 border rounded bg-light">
                    {result.otherFeedback ?? "No feedback available."}
                  </div>
                </div>
              )}

              {result?.sentences?.length > 0 && (
                <div className="mt-4">
                  <h5>Highlighted Sentences</h5>
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      padding: "20px",
                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #dee2e6",
                    }}
                  >
                    <p
                      style={{
                        lineHeight: "1.8",
                        fontSize: "1.05rem",
                        marginBottom: 0,
                      }}
                    >
                      {content.split(/(?<=[.?!])\s+/).map((sentence, index) => {
                        const trimmed = sentence.trim();

                        const isHighlighted =
                          Array.isArray(result.sentences) &&
                          result.sentences.some(
                            (s) =>
                              typeof s === "string" &&
                              s.trim().toLowerCase() === trimmed.toLowerCase()
                          );

                        return (
                          <span
                            key={index}
                            style={{
                              backgroundColor: isHighlighted
                                ? "#fff3cd"
                                : "transparent",
                              fontWeight: isHighlighted ? "bold" : "normal",
                              borderRadius: "6px",
                              padding: isHighlighted ? "3px 6px" : "0",
                              display: "inline",
                              marginBottom: "8px",
                            }}
                          >
                            {sentence + " "}
                          </span>
                        );
                      })}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          <Row className="justify-content-between">
            <Col md={8}>
              <Content />
            </Col>

            <Col md={3}>
              <div
                className="mb-5"
                style={{
                  position: "sticky",
                  top: "20px",
                  zIndex: 10,
                  background: "#f8f9fa",
                  padding: "1rem",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="text-center mb-4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    color: "#fff",
                    backgroundColor: "#799EFF",
                    display: "inline-block",
                    padding: "6px 16px",
                    borderRadius: "0.5rem",
                  }}
                >
                  🚀 Explore More SEO Tools
                </h5>
                <SideTab />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};
const GaugeCard = ({ title, value, max, color }) => {
  const percentage = Math.min((value / max) * 100, 100);
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div
      className="p-2 bg-white rounded border text-center"
      style={{
        boxShadow:
          "0 4px 8px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1)",
        width: 200,
        margin: "auto",
      }}
    >
      <h6 className="m-0 mb-2">{title}</h6>

      <div
        style={{
          position: "relative",
          width: "100%",
          height: 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <svg width="140" height="80">
          <circle
            cx="70"
            cy="70"
            r={radius}
            fill="transparent"
            stroke="#eee"
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={0}
            transform="rotate(-90 70 70)"
          />
          <circle
            cx="70"
            cy="70"
            r={radius}
            fill="transparent"
            stroke={color}
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 70 70)"
          />
        </svg>

        <div
          style={{
            position: "absolute",
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "1.4rem",
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="">
      <h2 className="mt-md-4">
        Content Quality Checker: Create High-Quality Content
      </h2>

      <p className="mt-2">
        Nowadays content is king in the busy digital world. Some of the areas
        that even the most creative writers fail to cope with include grammar
        errors, readability, and even SEO. Content Quality Checker would be
        required. It is software which will assist you in reducing your content
        and make it readable, wide and search engine friendly. Nonetheless,
        regardless of the disparity, you are a blogger or a marketer or a
        student; a quality checker will save time and will improve your writing
        in the current days.
      </p>

      <p className="mt-2">
        What does Content Quality Checker Mean? <br />
        Content Quality Checker is a Web based service that one can request to
        scan your writing to determine the mistakes, search engine optimization,
        readability and tone that you have made. It is also descriptive and
        examines its structure, flow and use of key-words contrary to the normal
        grammar checkers. It also has certain advanced checkers proposing some
        other words, active voice corrections and content enhancement to make
        the text more interesting. You will also be more satisfied with this
        tool that is more specific and has more chances of ranking higher in
        search engines and this will translate to higher traffic and higher
        contact.
      </p>

      <p className="mt-2">
        <strong>Best Benefits of a Quality Checker:</strong>
      </p>
      <ul>
        <li>
          Fix bugs: Spellings, grammar, punctuations etc. are automatically
          spotted.
        </li>
        <li>
          Make it easier to read: Examines sentence rhythm and readability
          score.
        </li>
        <li>
          Optimize the search engine: Keywords are checked and presented to
          improve ranking.
        </li>
        <li>
          Time Saving: Receive instant feedback and corrections compared to hand
          editing.
        </li>
        <li>
          Increase Interaction: Clean and clear content converts readers to
          regular visitors.
        </li>
      </ul>

      <div style={{ position: "relative" }}>
        <p className="mt-2">
          <strong>The Content Quality Checker Mechanism:</strong>
        </p>
        <ul>
          <li>
            Enter the Text: Click on the quality checker and type your text.
          </li>
          <li>
            Review and Analyze: Tool locates grammar, readability, optimization
            issues and checks keywords.
          </li>
          <li>
            Get Suggestions: Immediately replace with proposals to improve
            writing.
          </li>
          <li>
            Plagiarism Verification: Some tools check originality for authentic
            content.
          </li>
        </ul>

        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <p className="mt-2">
            <strong>Why It Helps Content Go Viral:</strong>
          </p>
          <p>
            Viral content is not only about catchy headlines. A captivating text
            must be comprehensible. A Content Quality Checker ensures your
            content is clear, structured, and shareable. SEO optimization
            increases reach and engagement, making your content more likely to
            go viral.
          </p>

          <p className="mt-2">
            <strong>The 3 Hacks for Improving Content Quality:</strong>
          </p>
          <ul>
            <li>Active Voice: Speak more forcefully in sentences.</li>
            <li>
              Readable Paragraphs: Internet readers prefer skimmable text.
            </li>
            <li>
              Market Keywords Intuitively: Tool guides proper keyword placement
              without stuffing.
            </li>
            <li>
              Check Tone and Style: Ensure content is clear, professional, or
              informative.
            </li>
            <li>
              Proofread Before Publication: Human review after using the
              checker.
            </li>
          </ul>

          <p className="mt-2">
            <strong>Importance of the Right Content Quality Checker:</strong>
          </p>
          <ul>
            <li>Spell check and real-time grammar check</li>
            <li>Readability scoring</li>
            <li>SEO and keyword analysis</li>
            <li>Plagiarism detection</li>
            <li>User-friendly interface</li>
          </ul>

          <h3>FAQ’s</h3>
          <ol>
            <li>
              <strong>What does Content Quality Checker do?</strong>
              <br />A web-based application that analyzes your text for grammar,
              readability, SEO, and overall quality, helping you produce
              professional and error-free content.
            </li>
            <li>
              <strong>
                Why will a Content Quality Checker help my content to be
                elevated?
              </strong>
              <br />
              It evaluates keyword usage, readability, and SEO optimization to
              ensure your content meets search engine standards, boosting
              visibility and organic traffic.
            </li>
            <li>
              <strong>
                Does a Content Quality Checker make my content viral?
              </strong>
              <br />
              Yes! Clear, readable, and shareable content increases the chances
              of trending on social media and blogs.
            </li>
            <li>
              <strong>Is it appropriate for bloggers and marketers?</strong>
              <br />
              Absolutely! It saves time, fixes errors instantly, and optimizes
              posts for better search engine rankings.
            </li>
            <li>
              <strong>Are Content Quality Checkers free?</strong>
              <br />
              Some are free with basic features; premium versions offer advanced
              SEO recommendations, plagiarism checks, and content analytics.
            </li>
          </ol>

          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <Testimonials />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <button
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </button>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const resultRef = useRef(null);
  const handleClick = () => {
    navigate("/bix-humanizer");
  };

  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const handleAnalyze = async () => {
    setError(null);
    setLoading(true);
    setResult(null);

    if (!content.trim()) {
      setError("Please paste some content before analyzing.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Seo/GetGenerativeTexts`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            meta_name: "Humanize content",
            relational_text: content,
            type: "2",
          }),
        }
      );

      const data = await response.json();
      const text = data?.candidates?.[0]?.content?.parts?.[0]?.text || "";

      if (!text) {
        setError("No humanized suggestions returned.");
        return;
      }
      setResult(text);
      setTimeout(() => {
        resultRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 200);
    } catch (err) {
      console.error("API Error:", err);
      setError("An error occurred while analyzing the content.");
    }

    setLoading(false);
  };

  return (
    <div className="mt-5 mb-5">
      <div style={{ cursor: "pointer" }}>
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Humanize Your Content</b>
            </h3>
            <p className="text-center">
              Turn robotic or AI-generated text into natural, human-sounding
              writing. Our Humanizer refines tone, flow, and structure to make
              your content feel authentic and undetectable by AI checkers.
            </p>

            <Form>
              <Form.Group
                className="mb-3"
                controlId="contentTextarea"
                style={{ position: "relative" }}
              >
                <MdContentPaste
                  style={{
                    position: "absolute",
                    top: "18px",
                    left: "20px",
                    fontSize: "1.5rem",
                    color: "#ccc",
                    pointerEvents: "none",
                    zIndex: "1",
                  }}
                />
                <Form.Control
                  as="textarea"
                  rows={7}
                  placeholder="Paste your content here..."
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  style={{
                    fontSize: "1rem",
                    padding: "1.25rem 1.25rem 1.25rem 3rem",
                    border: "1px solid #ccc",
                    borderRadius: "12px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                    transition: "box-shadow 0.3s ease-in-out",
                    resize: "vertical",
                    minHeight: "250px",
                  }}
                />
              </Form.Group>
              <Button
                variant="primary"
                onClick={handleAnalyze}
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Humanize"
                )}
              </Button>
            </Form>

            {error && (
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
            )}

            {result &&
              (() => {
                const lines =
                  result.match(/[^.!?]+[.!?]+/g)?.filter(Boolean) || [];
                const visibleCount = lines.length > 3 ? 3 : lines.length;
                const visibleLines = lines.slice(0, visibleCount);
                const hasMore = lines.length > visibleCount;

                return (
                  <>
                    <div
                      ref={resultRef}
                      style={{
                        marginTop: "1.5rem",
                        padding: "1.5rem",
                        background: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        fontSize: "1rem",
                        lineHeight: "1.6",
                        whiteSpace: "pre-line",
                        position: "relative",
                        maxHeight: hasMore ? "220px" : "none",
                        overflow: "hidden",
                      }}
                    >
                      {visibleLines.map((line, idx) => (
                        <p key={idx} style={{ marginBottom: "0.75rem" }}>
                          {line}
                        </p>
                      ))}

                      {hasMore && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "60px",
                            background:
                              "linear-gradient(to bottom, rgba(255,255,255,0), #fff)",
                          }}
                        />
                      )}
                    </div>

                    {hasMore && (
                      <h6
                        className="text-end m-4"
                        onClick={handleClick}
                        style={{ cursor: "pointer" }}
                      >
                        Click to get full content <FaArrowRight />
                      </h6>
                    )}
                  </>
                );
              })()}
          </Col>
        </Row>
      </div>
    </div>
  );
};

const cardData = [
  {
    title: "Content Quality Checker",
    description:
      "Instantly check your content for grammar, readability, keyword usage, and SEO structure. Get clear, actionable feedback to improve your writing in seconds.",
    linkText: "Check Content Quality",
    linkUrl: "/content-quality-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Humanizer Tool",
    description:
      "Convert robotic AI-generated text into human-like, natural writing. Bypass AI detectors and make your content feel more authentic.",
    linkText: "Use Humanizer",
    linkUrl: "/ai-humanizer-tool",
    bgColor: "#dff5ff",
  },
  {
    title: "Bix content generator",
    description:
      "Generate high-quality blog posts, product descriptions, intros, and more from a single keyword. Smart, fast, and human-sounding.",
    linkText: "Start Generating",
    linkUrl: "/bix-content-generator",
    bgColor: "#f4f7fb",
  },
  {
    title: "DA/PA Checker",
    description:
      "Evaluate domain authority and page authority instantly. Understand your SEO strength and compare with competitors in real-time.",
    linkText: "Check DA/PA",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];

const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Content Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Contentquality;
